export default __webpack_public_path__ + "static/media/road-icon.c7a6a870.svg";